import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VcsService } from '../../../services/vcs.service';
import { BaseComponent } from '../../../../components/base/base.component';
import { VcsAPIService } from '../../../services/vcs-api/vcs-api.service';
import { WmsDialogComponent } from '../../../../components/wms-dialog/wms-dialog.component';
import { WmsDialogHeaderComponent } from '../../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { WmsVcsViewCommitChangesDialogComponent } from '../wms-vcs-view-commit-changes-dialog/wms-vcs-view-commit-changes-dialog.component';
import { ICommit } from '@wms/app/vcs/interface/commit';
import { replace } from "@wm/core";
import { PopoverModule } from "ngx-bootstrap/popover";
@Component({
  selector: 'wms-vcs-commit-history-dialog',
  templateUrl: './wms-vcs-commit-history-dialog.component.html',
  styleUrls: ['./wms-vcs-commit-history-dialog.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsVcsViewCommitChangesDialogComponent,
    PopoverModule
  ],
})
export class WmsVcsCommitHistoryDialogComponent extends BaseComponent {
  public vcsService: VcsService;
  private vcsAPIService: VcsAPIService;

  public selectedCommit:ICommit = {
    author: {
      email: '',
      name: '',
    },
    commitId: '',
    commitMessage: '',
    commitTime: 0,
  };
  commitStatus = "";
  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsAPIService = inject(VcsAPIService);
  }

  toggleButton(commit: ICommit) {
    commit.state = (commit.state === 'less' || !commit.state) ? 'more' : 'less';
  }

  showFilesListByCommit(commit: ICommit) {
    this.selectedCommit = commit;
    this.vcsAPIService.loadSingleCommitLogs(commit.commitId).then((response): void => {
      this.vcsService.commitHistoryChanges = response
      this.vcsService.openDialogWithId('vcsFilesListByCommitDialog');
    });
  }

  setOffset(direction:string){
    if (direction === 'next') {
      this.vcsService.offset += 10;
  } else {
      this.vcsService.offset -= 10;
  }
    this.vcsService.isDisablePrevious = this.vcsService.offset === 0 ? true : false;
    this.vcsService.isDisableNext = false;
    this.vcsService.getCommitsLog();
  }

  getCommitStatus() {
      const args = {
        remoteBranch : this.vcsService.gitStatus.repoRemoteTrackingStatus.remoteTrackingBranchName,
        devBranch: this.vcsService.gitStatus.devBranchTrackingStatus?.developmentBranch,
        pullRequest:  this.locale['LABEL_MERGE_REQUEST_' + this.projectService.teamProjectObject.vcsAccountDTO.vcsAccountType] || this.locale.LABEL_MERGE_REQUEST_DEFAULT
      };
      this.commitStatus = replace(this.locale['MSG_COMMIT_STATUS'], args) || '';
  }
}
